import ApplicationController from "./application_controller"
import GvToast from "../lib/gv_toast"

// Plain-file-input upload for User profile/banner images -- posts straight to
// UserImagesController's existing create/update actions (see UserImagesController#user_image_params),
// bypassing the legacy Jcrop modal per docs/givsum3_08_july.md Section 9 ("never reintroduce cropping").
export default class extends ApplicationController {
  static values = {
    url: String,
    fieldName: String,
    existingId: String
  }

  save(event) {
    const file = event.detail.file
    if (!file) return

    const formData = new FormData()
    formData.append("user_image[image]", file)
    formData.append("user_image[field_name]", this.fieldNameValue)
    if (this.existingIdValue) formData.append("user_image[id]", this.existingIdValue)

    const token = document.querySelector('meta[name="csrf-token"]')
    this.setBusy(true)

    fetch(this.urlValue, {
      method: this.existingIdValue ? "PATCH" : "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": token ? token.content : ""
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        window.location.reload()
      })
      .catch(() => {
        this.setBusy(false)
        GvToast.error("The image could not be uploaded. Please try again.")
      })
  }

  setBusy(isBusy) {
    const loader = document.getElementById("global-ajax-loader")
    if (loader) loader.classList.toggle("d-none", !isBusy)
  }
}
